import { memo, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import * as ui from '@april9au/stack9-ui';
import { useRefreshList } from '@april9au/stack9-ui';

import { PermissionSetCreateDrawer } from '../pages/permission-set/PermissionSetCreateDrawer';
import { BookingDrawer } from './BookingDrawer/BookingDrawer';
import { EventDrawer } from './EventDrawer/EventDrawer';
import HealthScreenDrawer from './HealthScreen/HealthScreenDrawer';
import ResourceDrawer from './Resource/ResourceDrawer';

const S9Button = ui.S9Button.default;
const S9Space = ui.Space;
const { ScreenProvider } = ui;

const HealthScreenActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = ui.useRefreshList();

  return (
    <>
      <S9Space>
        <S9Button
          label="Create"
          onClick={() => setIsOpen(true)}
          type="primary"
        />
      </S9Space>
      <HealthScreenDrawer
        open={isOpen}
        id={undefined}
        onSaved={() => {}}
        onDeleted={() => {}}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
    </>
  );
};

const ResourceDetailActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <>
      <S9Space>
        <S9Button
          label="Create"
          onClick={() => setIsOpen(true)}
          type="primary"
        />
      </S9Space>
      <ResourceDrawer
        open={isOpen}
        id={undefined}
        onSaved={() => {}}
        onDeleted={() => {}}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
    </>
  );
};

const EventActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <>
      <S9Space>
        <S9Button
          label="Create"
          onClick={() => setIsOpen(true)}
          type="primary"
        />
      </S9Space>
      <EventDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
    </>
  );
};

const BookingActions = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <>
      <S9Space>
        <S9Button
          label="Create"
          onClick={() => setIsCreateOpen(true)}
          type="primary"
        />
      </S9Space>
      <ScreenProvider relativePath="/crm/booking-create-drawer">
        <BookingDrawer
          open={isCreateOpen}
          onClose={() => {
            setIsCreateOpen(false);
            refresh();
          }}
        />
      </ScreenProvider>
    </>
  );
};

const PermissionSetActions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <>
      <S9Space>
        <S9Button
          label="Create Permission Set"
          onClick={() => setIsOpen(true)}
          type="primary"
        />
      </S9Space>
      <PermissionSetCreateDrawer
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
    </>
  );
};

export const ActionBarComponent = memo(
  ({ defaultActions }: ui.ActionBarComponentProps) => (
    <>
      {defaultActions}
      <Routes>
        <Route path="/health-screen/list" element={<HealthScreenActions />} />
        <Route path="/resource/list" element={<ResourceDetailActions />} />
        <Route path="/events-list" element={<EventActions />} />
        <Route path="/bookings-list" element={<BookingActions />} />
        <Route path="/permission-set" element={<PermissionSetActions />} />
      </Routes>
    </>
  ),
);
